export default {
    amountBox: {
        marginTop: "40px",
        cursor: "pointer"
    },
    card: {
        marginTop: "20px"
    },
    bankName: {
        margin: "0"
    },
    cardInformation: {
        display: "flex",
        columnGap: "10px",
        justifyContent: "center",
        alignItems: "center"
    },
    actionButtons: {
        margin: "35px 0",
        display: "flex",
        columnGap: "40px"
    },
    iconLabelContainer: {
        columnGap: "6px",
        cursor: "pointer"
    },
    cvvInfo: {
        fontSize: "16px",
        fontWeight: "600",
        color: "#215DAA"
    },
    cvvDetails: {
        marginTop: "40px",
        display: "flex",
        flexDirection: "column",
        alignItems: "end",
        rowGap: "5px"
    },
    cvvInput: {
        width: "60%"
    },
    cardText: {
        fontSize: "14px"
    },
    pointer: {
        cursor: "pointer"
    },
}